module.exports = "/_next/static/images/australia-duotone-86712aa8eec58577173556187a97464a.svg";